import { Provider, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { SecurityConfig, SECURITY_CONFIG } from '../models/security-config.interface';
import { EncryptionInterceptor } from '../interceptors/encryption.interceptor';
import { DecryptionInterceptor } from '../interceptors/decryption.interceptor';
import { initializeSecurityFactory } from '../initializers/security.initializer';
import { CryptoService } from '../services/crypto.service';

/**
 * Complete security provider: config + interceptors + APP_INITIALIZER
 * App blocks until public key is fetched and verified
 * 
 * @example
 * provideSecurity({
 *   enableEncryption: true,
 *   publicKeyEndpoint: environment.apiUrl + '/crypto/init',
 *   expectedPublicKeyHash: 'f2a9e8cc...',
 *   encryptDecryptForEndpoints: ['/insurance/*'],
 *   enableDebugLogging: false,
 *   publicKeyFetchRetries: 3
 * })
 */
export function provideSecurity(config: SecurityConfig): Provider[] {
  return [
    { provide: SECURITY_CONFIG, useValue: config },
    { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DecryptionInterceptor, multi: true },
    { 
      provide: APP_INITIALIZER, 
      useFactory: initializeSecurityFactory,
      deps: [HttpClient, CryptoService, SECURITY_CONFIG],
      multi: true 
    }
  ];
}
